<script lang="ts" setup>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import { DownloadCenter, PrivacyDialog } from '@mp/component'
import { useRoute } from 'vue-router'
import type { SPTrackConfig } from '@sp/track'
import { useTrackModule } from '@sp/track'
import { ZF_NO } from '@mp/constant'
import router from '@/router'
import { toOldB, useIsSp, useUserInfo } from '@mp/hooks'
import { computed } from 'vue'
import { Sort } from '@element-plus/icons-vue'

const route = useRoute()
const { userInfo } = useUserInfo()
const isHomePageRouteNames = ['HomePage', undefined] as string[]

// ? 非首页
const isNotHomePage = computed(() => !isHomePageRouteNames.includes(route.name as string))

const { isNotSp, company, favicon } = useIsSp()
if (isNotSp) {
  document.title = company
  document.getElementById('favicon')?.setAttribute('href', favicon)
}

const trackConfig: SPTrackConfig = {
  debug: import.meta.env.MODE !== 'production',
  env: import.meta.env.MODE === 'development' ? 'test' : 'prod',
  appId: ZF_NO,
  appletId: ZF_NO,
  router,
  infoBridge: {
    getUserId() {
      return userInfo.value?.memberId || new Date().getTime().toString()
    },
    getSessionId() {
      return userInfo.value?.memberId || new Date().getTime().toString()
    },
    getDeviceId() {
      return window.deviceCode || new Date().getTime().toString()
    },
  },
}

useTrackModule().config(trackConfig)

// 回到旧版
async function handleBackToOldB() {
  toOldB()
}
</script>

<template>
  <ElConfigProvider :locale="zhCn">
    <RouterView />

    <template v-if="isNotHomePage">
      <!-- 回到旧版 -->
      <div v-if="!isNotSp" class="fixed bottom-36 right-6 z-10 text-center" @click="handleBackToOldB">
        <el-button id="BACK_OLD_B" v-track :icon="Sort" circle size="large" class="rotate-90" />
        <p class="mt-1 text-xs text-n-400">
          回到旧版
        </p>
      </div>

      <DownloadCenter />
      <PrivacyDialog />
    </template>
  </ElConfigProvider>
</template>

<style>
:root {
  --el-color-primary: #0094FF;
  /* --el-border-radius-small: 8px; */
  --el-color-warning: #FA8C16;
}

body {
  min-width: 1280px;
  background-color: #F5F7FA;
}

.content-container {
  @apply max-w-[1920px] px-8 relative mx-auto;
}
</style>
